<script>
    import { Link, navigateTo } from 'yrv';
    export let url = '/'
    export let label = 'Link'
</script>

<style>
    .SidepanelLink :global(a) {
        display: block;
        color: var(--forge-primary-fg);
        text-decoration: none;
        padding: 0 15px;
        line-height: 28px;
        font-weight: 600;
        font-size: 14px;
        border-radius: 3px;
    }
    .SidepanelLink:hover :global(a) {
        background-color: var(--sidelink-hover)
    }
    .SidepanelLink :global(a[aria-current="page"]) {
        background-color: var(--forge-primary-selected)
    }
</style>

<div class="SidepanelLink">
    <Link class="SideLink" href={url} exact>
        {label} 
    </Link>
</div>